import { validateResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
import { getConfigResponse } from "./specs.js";
const getConfig = async (apiUrl, { scope }, init) => {
  return validateResponse(
    getConfigResponse,
    await fetch(`${apiUrl}/upload/config/${scope}`, {
      method: "GET",
      headers: {
        ...acceptJson
      },
      ...init
    })
  );
};
export {
  getConfig
};
//# sourceMappingURL=get-config.js.map
